import { atom } from "jotai";

import type { stacks } from "@dropbox/api-v2-client";

/**
 * Atom used to store search results for stacks search. `null` value
 * means no search is being performed
 */
export const stackSearchStacksAtom = atom<stacks.Stack[] | null>(null);
